import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
 
@Injectable({
  providedIn: 'root'
})
export class DuplicateShipmentService {
    dupShipmentObj = {
        getProductTypes: false,
        getCountry: false,
        isCitySelect: false,
        isSelectProductCall: false
    }

    private duplicateShipmentSource = new BehaviorSubject(this.dupShipmentObj);
    shipmentObservable = this.duplicateShipmentSource.asObservable();
    
    setData(data: any) {
        let obj = {...this.dupShipmentObj,...data}
        this.duplicateShipmentSource.next(obj);
    }
    
    constructor() { }
}